import { Box } from "@material-ui/core";
import styled from "styled-components";


export const Title = styled.div`
        font-size: 18px;
        color: ${props => props.theme.colors.textBold};
        font-weight: 700;
        margin-bottom: 16px;
`

export const TableHead = styled.div`
        display: flex;
        align-items: center;
        padding: 0px 6px 8px;
        border-bottom: 2px solid ${props => props.theme.colors.textBold};
`

export const CellHead = styled.span`
        font-size: 12px;
        color: ${props => props.theme.colors.textBold};
        font-weight: bold;
`

export const TableBody = styled(Box)`
        font-size: 12px;
`
export const TableRow = styled.div`
        display: flex;
        align-items: flex-start;
`

export const TableCell = styled.span`
        font-size: 13px;
`

export const TableRowContent = styled.div`
        display: flex;
        flex-direction: column;
        padding: 6px;
        border-bottom: 1px solid #E2E2E2;
        background-color: ${(props) => props.odd ? '#F9F9F9' : '#FFF'};
`

export const TotalBox = styled.div`
        display: flex;
        flex-direction: column;
        width: 100%;
        justify-content: center;
        align-items: flex-end;
`

export const TotalBoxRow = styled.div`
        display: flex;
        width: calc(15% + 122px);
        padding: 1px 6px;
        background-color: ${(props) => props.odd ? '#F9F9F9' : '#FFF'};
        border-bottom: 1px solid #E2E2E2;
`

export const TotalBoxCell = styled.div`
        font-size: 13px;
  
`